module.exports = __webpack_public_path__ + "static/media/home_banner.043d16b2.webp";